import React from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

function Process() {
    return (
        <div className="skolkovo-kids__process">
            <div className="skolkovo-kids__process-inner">
                <div className="skolkovo-kids__process-title">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        Процесс
                    </ScrollAnimation>
                </div>
                <div className="skolkovo-kids__process-wrapper">
                    <div className="skolkovo-kids__process-texts">
                        <div className="skolkovo-kids__process-text">
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                            >
                                На&nbsp;запуск новой площадки у&nbsp;нас с&nbsp;командой
                                &laquo;Сколково&raquo; было не&nbsp;больше недели. Наполнили группу
                                контентом, перенесли посты из&nbsp;заблокированных соцсетей. Также
                                адаптировали все креативы <br /> и&nbsp;стиль подачи под новую
                                аудиторию и&nbsp;новую соцсеть с&nbsp;ее&nbsp;алгоритмами.
                            </ScrollAnimation>
                        </div>

                        <div className="skolkovo-kids__process-text">
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                            >
                                Для продвижения на&nbsp;первом этапе пробовали классический подход:
                                брали посты из&nbsp;сообщества и&nbsp;промотировали
                                их&nbsp;по&nbsp;контекстному таргетингу и&nbsp;интересам. CTR был
                                всего 0,104%. И&nbsp;несмотря <br /> на&nbsp;охваты до&nbsp;100К,
                                прибавилось всего 49&nbsp;новых подписчиков.
                            </ScrollAnimation>
                        </div>

                        <div className="skolkovo-kids__process-text">
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                            >
                                Ранее из&nbsp;другой рекламной системы получали около 500
                                подписчиков в&nbsp;день по&nbsp;цене 30-50&nbsp;руб.
                                Но&nbsp;&laquo;ВКонтакте&raquo; требовал другого подхода.
                            </ScrollAnimation>
                        </div>

                        <div className="skolkovo-kids__process-text skolkovo-kids__process-text--accent">
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                            >
                                Основной сложностью стал поиск релевантных аудиторий.
                            </ScrollAnimation>
                        </div>

                        <div className="skolkovo-kids__process-text">
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                            >
                                Идеальная ЦА&nbsp;проекта&nbsp;&mdash; технологичные родители,
                                которым нужно с&nbsp;ранних лет прививать ребенку ценности
                                инноваторов и&nbsp;искать новые направления развития, а&nbsp;также
                                дети, которые хотят быть на&nbsp;&laquo;ты&raquo;
                                с&nbsp;технологиями, взаимодействовать с&nbsp;единомышленниками
                                и&nbsp;экспериментировать.
                            </ScrollAnimation>
                        </div>

                        <div className="skolkovo-kids__process-text">
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                            >
                                За&nbsp;апрель-май протестировали более 30&nbsp;таргетингов,
                                различные варианты текстов и&nbsp;креативов. Лучше всего отработали
                                аудитории родителей. Добавили к&nbsp;ним группы с&nbsp;интересами
                                по&nbsp;финансовой грамотности, развития soft-skills у&nbsp;детей
                                и&nbsp;сообщества педагогов.
                            </ScrollAnimation>
                        </div>

                        <div className="skolkovo-kids__process-text">
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                            >
                                Сменили креативную концепцию&nbsp;&mdash; оставили однотонные имиджи
                                с&nbsp;текстом &laquo;Дети в&nbsp;Сколково&raquo;, используем
                                максимум живых фотографий и&nbsp;видео с&nbsp;мероприятий.
                            </ScrollAnimation>
                        </div>

                        <div className="skolkovo-kids__process-text">
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                            >
                                На&nbsp;широкую аудиторию по&nbsp;гео &laquo;вся Россия&raquo;
                                таргетировали посты <br /> про онлайн-конкурсы, олимпиады
                                и&nbsp;фестивали, приглашения <br /> на&nbsp;онлайн-встречи
                                с&nbsp;экспертами из&nbsp;мира финансов, предпринимательства,
                                психологии, ИТ-разработки, дизайна. Для аудитории педагогов
                                описывали возможности для детей в&nbsp;возрасте 10-15&nbsp;лет,
                                и&nbsp;что они получат <br /> от&nbsp;занятий.
                            </ScrollAnimation>
                        </div>
                    </div>

                    <div className="skolkovo-kids__process-images">
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                        >
                            <img
                                className="skolkovo-kids__process-image"
                                src="/images/pic/skolkovo-kids/process1.png"
                                alt="process1"
                            />
                        </ScrollAnimation>
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                        >
                            <img
                                className="skolkovo-kids__process-image"
                                src="/images/pic/skolkovo-kids/process2.png"
                                alt="process2"
                            />
                        </ScrollAnimation>
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                        >
                            <img
                                className="skolkovo-kids__process-image"
                                src="/images/pic/skolkovo-kids/process3.png"
                                alt="process3"
                            />
                        </ScrollAnimation>
                    </div>
                </div>

                <div className="skolkovo-kids__process-promotion">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <img
                            className="skolkovo-kids__process-promotion-image"
                            src="/images/pic/skolkovo-kids/rocket.png"
                            alt="rocket"
                        />
                    </ScrollAnimation>
                    <div className="skolkovo-kids__process-promotion-list">
                        <div className="skolkovo-kids__process-promotion-title">
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                            >
                                За три летних месяца продвижения сообщества:
                            </ScrollAnimation>
                        </div>
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                        >
                            <div className="skolkovo-kids__process-promotion-item">
                                на&nbsp;80% улучшили CTR;
                            </div>
                        </ScrollAnimation>

                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                        >
                            <div className="skolkovo-kids__process-promotion-item">
                                на&nbsp;39% снизили стоимость перехода;
                            </div>
                        </ScrollAnimation>

                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                        >
                            <div className="skolkovo-kids__process-promotion-item">
                                уменьшили количество негативных реакций и&nbsp;скрытых рекламных
                                записей.
                            </div>
                        </ScrollAnimation>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Process;
